import useNotificationToasts from "./useNotificationToasts";

const configuration = {
  kind: "BACKGROUND_JOB_FINISHED", prefix: "background-job-finished", includeBacklog: true,
  isEnabled: () => true,
  eligible: row => typeof row.source_path === "string" && row.source_path.startsWith("/") && !row.source_path.startsWith("//"),
  title: row => `${row.job_label} · ${row.job_status === "COMPLETED" ? "Completed" : row.job_status.replaceAll("_", " ").toLowerCase()}`,
  description: () => "Your server job has finished. Open the original page to review its result.",
  actionLabel: "Open job page",
};

export default function useJobNotificationToasts(resource, onView, onFailure) {
  useNotificationToasts(resource, onView, onFailure, configuration);
}
